import { AllMedicationsIcon } from '../assets/svgImages';
import { ShopAllMedicationsProps } from '../interface/interface';

const ShopAllMedications = ({ className }: ShopAllMedicationsProps) => {
  return (
    <a className={className} href="/storefront">
      <span className="mr-4 lg:mr-0 block">
        <AllMedicationsIcon />
      </span>
      <span className="lg:mt-6 lg:w-1/2">shop all medications</span>
    </a>
  );
};
export default ShopAllMedications;
